var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{staticClass:"ml-10 pr-15",attrs:{"id":_vm.id,"height":"80"}})])}
var staticRenderFns = []

export { render, staticRenderFns }